import {TranslationObject} from '@colonist/i18n'
import {RoomState} from '../../../../../shared/RoomState'

export abstract class UIRoomWarningPopupContentBase {
    protected readonly roomState: RoomState

    constructor(roomState: RoomState) {
        this.roomState = roomState
    }

    abstract shouldShowWarning(): boolean
    abstract getTitle(): TranslationObject
    abstract getDescription(): TranslationObject
}
